export default __webpack_public_path__ + "static/saf-webfont-efa8ecd35406d354dec416a0ae4bf6f4.woff";